import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";

import { VtoCategory, VtoConfiguration } from "@hermes/api-model-vto";
import { LOCALE, Settings } from "@hermes/app-core";
import { Locale } from "@hermes/locale";
import { Logger } from "@hermes/logger";
import { HTTP_JSON_CONTENT_TYPE_HEADER } from "@hermes/utils-generic/constants";
import { LOGGER } from "@hermes/web-logger";

/**
 * @deprecated
 * This service expose methods for the old Virtual Try On (VTO) version.
 *
 */
@Injectable()
export class DeprecatedVtoService {
    constructor(
        private settings: Settings,
        private http: HttpClient,
        @Inject(LOGGER) private logger: Logger,
        @Inject(LOCALE) private locale: Locale,
    ) {}

    public getVtoConfiguration(): Observable<VtoConfiguration> {
        return this.http
            .get<VtoConfiguration>(
                `${this.settings.apiUrl}/vto/configuration`,
                {
                    headers: new HttpHeaders({
                        ...HTTP_JSON_CONTENT_TYPE_HEADER,
                    }),
                },
            )
            .pipe(
                catchError((error) => {
                    this.logger.error(
                        "Error during call of VTO configuration",
                        error,
                    );
                    return [];
                }),
            );
    }

    public getVtoCategories(): Observable<VtoCategory[]> {
        return this.http
            .get<VtoCategory[]>(`${this.settings.apiUrl}/vto/products`, {
                headers: new HttpHeaders({
                    ...HTTP_JSON_CONTENT_TYPE_HEADER,
                }),
            })
            .pipe(
                catchError((error) => {
                    this.logger.error(
                        "Error occured when getting vto categories",
                        error,
                    );
                    return [];
                }),
            );
    }
}
